enum FilterPopoverTabs {
  Placements,
  Pixels,
}

export default FilterPopoverTabs;
